// extracted by mini-css-extract-plugin
export default {"message":"styles_message__fGO7+","info":"styles_info__QuWQ8"};